<template>
  <Content class="col-span-full" :title="$route.name" type="list">
    <tableSearch
      @search="search = $event"
      :placeholder="
        $t('SEARCH_FOR', {
          type: $t('TITLE'),
        })
      "
    />

    <el-table
      :empty-text="$t('NO_DATA')"
      :data="tableData.filter((data) => !search || data.title.includes(search))"
      v-loading="loading"
      :stripe="true"
      style="width: 100%"
    >
      <el-table-column
        sortable
        type="index"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('INDEX')"
        width="60"
      >
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('TITLE')"
        width="160"
      >
        <template slot-scope="scope">
          <div :data-title="$t('TITLE')" class="flex">
            {{ scope.row.title }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('USERS')"
        width="160"
      >
        <template slot-scope="scope">
          <div :data-title="$t('USERS')" class="flex flex-wrap gap-2">
            <el-tag v-for="item in scope.row.users" :key="item.id">
              {{ item.username }}
            </el-tag>
          </div>
        </template>
      </el-table-column>

      <!-- <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('DATE')"
        width="120"
      >
        <template slot-scope="scope">
          <div :data-title="$t('DATE')">
            {{ scope.row.date | getPersianDate }}
          </div>
        </template>
      </el-table-column> -->

      <el-table-column label="" width="170">
        <template slot-scope="scope">
          <div class="fixed-column">
            <tableFeatures
              :description="scope.row.description"
              :isDeleteable="false"
              :router="{
                name: 'EDIT_ORGANIZATION',
                id: scope.row.id,
              }"
              :title="$t('VEHICLE_SERVICE')"
              @open="open($event)"
              @view="view($event, 'VIEW_ORGANIZATION')"
              :view="true"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
  </Content>
</template>

<script>
import { organizationList } from '@/api/acl'
import tableFeatures from '@/components/elements/tableFeatures'
import { open } from '@/mixins/openDesc'
import { view } from '@/mixins/viewPage'
import tableSearch from '@/components/elements/tableSearch'

export default {
  mixins: [open, view],
  data() {
    return {
      tableData: [
        {
          title: '',
        },
      ],
      loading: true,
      search: '',
    }
  },

  methods: {},
  mounted() {
    organizationList.api().then((res) => {
      if (res) {
        this.tableData = res
      }
      this.loading = false
    })
  },
  components: {
    tableFeatures,
    tableSearch,
  },
}
</script>
